import React, { useEffect, useState,useCallback , useRef} from 'react'

import LoadingPage from '../../others/LoadingPage'

 import toast from 'react-hot-toast';
import ViewReviewDetails from './ViewReviewDetails';
import UpdateReviewDetails from './UpdateReviewDetails';

function FTreviewPage({User}) {


  const apiUrl = process.env.REACT_APP_API_URL 

  const seckey =process.env.REACT_APP_REV_KEY

 const [selectedValue, setSelectedValue] = useState(null);
  const [page, setPage] = useState(1);
 const [ResponsePageData, setResponsePageData] = useState("");
 
 
 const [data,setData] = useState({

    customerName:"",
    servicesName:"",
    BreedName:"",
    serviceDate:"",
    ratingNumber:"",
    ratingMessage:""

  });



  const [loading, setloading] = useState()

  const [reviewsData , setReviewsData] = useState("")
    const [reviwStar , setReviwStar] = useState("");
    const [OpenAddReviews, setOpenAddReviews] = useState(false  )



 const [showPopup, setShowPopup] = useState(false);
  const [selectedId, setSelectedId] = useState(null);


  const handleViewClick = (id) => {
    setSelectedId(id); 
    setShowPopup(true);  
  };




  // For Update :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::



 const [selectedReview, setSelectedReview] = useState(null);
const [OpenEditReviews, setOpenEditReviews] = useState(false);

const handleEditClick = (review) => {
  setSelectedReview(review);
  setOpenEditReviews(true);
};







  const getReviews =async(page)=>{
    setloading(true)
    try {
      const response = await fetch(`${apiUrl}/auth/get-ft-ratting?page=${page}`,{
      method:"GET",
      headers:{ 
        context:"application/json",
        seckey:seckey,
      },
      })
      
      const data = await response.json();
      if(response.ok){
          setReviewsData(data.data)
          setResponsePageData(data)

      }else if(response.status === 401 || 404){
        console.log("Unothorised accesss")

      }
      else{
        console.log("Fercing reiews fail");
      }

    } catch (error) {
      
      console.log(error)
    }
    setloading(false)
  }  

      const prevPage = () => {
  if (page > 1) {
    setPage(page - 1);
  }
};


const nextPage = () => {
  if (page < ResponsePageData.totalPages) {
    setPage(page + 1);
  }
};


  // Star APi :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::



    const getReviewsStar = async()=>{
    setloading(true)
    try{
      const response = await fetch(`${apiUrl}/auth/get-ft-start-ratting`,{
        method:"GET",
        headers:{
          "Content":"application/json",
          seckey:seckey,
        }
      })
      const data = await response.json()
      if(response.ok){
        setReviwStar(data)
       
      }
    }catch(error){

      console.log(error)
    }
     setloading(false)
  } 


      const hasFetched = useRef(false);



  useEffect(()=>{


      getReviews(page);
      getReviewsStar();

console.log("APi caliing")

  },[page])



  // SUBMIT FORM API  :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  // :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::



  const handleFromChange =(e)=>{

  const { name, value } = e.target;

  setData((prevData) => ({
    ...prevData,
    [name]: value,
  }));

  }

const handleSelect = (num) => {
  setSelectedValue(num);
  setData((prev) => ({
    ...prev,
    ratingNumber: num,
  }));
};




  const handleSubmitReviews =  async(e)=>{
    e.preventDefault();


    if(data.ratingNumber === null){
      toast.error("Please Select Rating Number"

      )
      return null
    }

    setloading(true)
    try {

        const response = await fetch (`${apiUrl}/auth/post-ft-reviews`,{

          method:"POST",
          headers:{
          "Content-Type":"application/json",
          seckey:seckey,
          },
          body:JSON.stringify(data)
        },)

        const data2= await response.json();

        if(response.ok){

          toast.success(data2.message)
          getReviews();
          getReviewsStar();
        }


          setData({
          customerName: "",
          servicesName: "",
          serviceDate: "",
          BreedName:"",
          ratingNumber: null,
          ratingMessage: ""
        });
          setSelectedValue("");

    } catch (error) {
      console.log(error)
      toast.error("Server Error")
      
    }
    setloading(false)
  
  }






  const DeleteRatingApi  =async(id)=>{

    try {
      const  response = await fetch(`${apiUrl}/auth/delete-ft-rating/${id}`,{
        method:"DELETE",
        headers:{
          "Content-Type":"application/json",
          seckey:seckey
        },
         credentials: "include",
      })

      const data = await response.json();
      if(response.ok){

         toast.success(data.message)
         getReviews();
          getReviewsStar();
      }else if(!response.ok){
        toast.error(data.message)
      }else{
        toast.error('try again')
      }
      
    } catch (error) {
      console.log(error);
    }

  }





  // console.log("faltu 1",reviewsData)
  // console.log("faktu2 ",reviwStar)



  //   if (loading) {
  //   return <LoadingPage />;
  // }














  return (

    <div>
      <div className='glazma-reiewspage-bg'>
  
<div className='glazma-reviews-home-header'>

  <div>ID, {User.iat}</div>
</div>



{

  OpenAddReviews === true ?

  <form onSubmit={handleSubmitReviews}>

        <div className='show-add-reviews-component'>
             <div className='show-add-reviews-close-btn'> <div onClick={()=>setOpenAddReviews(false)}>  <i class="fa-regular fa-rectangle-xmark"></i> </div> </div>
            <div className='show-add-reviews-form-content'>


              <div className='show-add-reviews-form-content-row'>
                <div> 
                  <input placeholder=' Enter Customer Name' required name="customerName" value={data.customerName} onChange={handleFromChange} />
                  </div>
                 <div> 
                      <input  placeholder='Enter service Name' required name="servicesName" value={data.servicesName} onChange={handleFromChange} />

                 </div>

              </div>

              <div className='show-add-reviews-form-content-row'>


              <div className='add-review-select-date'>
                    <label> Select Service Date:</label>   
                   
                         <input type='Date' required  name='serviceDate' value={data.serviceDate} onChange={handleFromChange} ></input>  </div>
                   
             

                    <div>
                
                     <input type='test' placeholder='Breed Name' required  name='BreedName' value={data.BreedName} onChange={handleFromChange} ></input>  

              </div>



                    </div>









                    

              <div className='show-add-rev-from-text-area'>
                <textarea name='ratingMessage'  value={data.ratingMessage} placeholder='Reviews message' rows={8} onChange={handleFromChange} ></textarea>
               </div>
                 <div className='show-add-radding-rows'>
                    {[1, 2, 3, 4, 5].map((num) => (
                      <div
                        key={num}
                        className={`show-add-radding-cols ${selectedValue === num ? 'selected-start-form-number' : ''}`}
                        onClick={() => handleSelect(num)}
                      >
                        {num}
                      </div>
                    ))}
                    </div>


                      {

                          loading === true ?

                        <div className='add-reviews-submit-btn'>
                              <div>Loading...</div>
                            </div>
                                        :
                            <div className='add-reviews-submit-btn'>
                              <button type='submit'>Submit</button>
                            </div>
                        }


              </div>
      
        </div>
        </form>

  :""
}



{/* ::Top Reports Data:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: */}


      <div className='top-show-rating-details-reviews-cotent'>

        <div  className='glazma-total-rev-content'>

          <div>{reviwStar.total}</div>
          <div>Total Reviews</div>
        </div>


              <div className='reviews-bars-progress-cont'>


            <ul>
              {reviwStar && reviwStar.distribution && reviwStar.total ? (() => {
                const totalReviews = Number(reviwStar.total); 

                return Object.entries(reviwStar.distribution)
                  .sort((a, b) => b[0] - a[0])
                  .map(([rating, count]) => {
                    const starCount = Number(count);

                    return (
                      <div className='rev-progress-outer-div-cont' key={rating}>
                        <div className='rev-progress-outer-start'>
                          <span><i className="fa-solid fa-star"></i> {rating}</span>
                        </div>

                        <progress

                          style={{
                            width: "100%",
                            height: "2px",
                            background:"green",
                          
                          }}
                          value={starCount}
                          max={totalReviews}
                        />

                        <p className='rev-star-count-value-cont'> {starCount}K</p>
                      </div>
                    );
                  });
              })() : (
                <li>No data available.</li>
              )}
            </ul>



            </div>




      </div>


{/* ADD REVIEWS FORM::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: */}
{/* ADD REVIEWS FORM::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: */}


      <div className='glazma-reviews-search-container'>  
      
      <div>
        {/* <input  placeholder='search'></input> */}
        </div>

                 <div className='dashboard-add-glazma-rev-btn' onClick={()=>setOpenAddReviews(true)}>+Add</div>
        
        </div>






{/* Liste User Reviews section ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: */}
{/* Liste User Reviews section ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: */}


<div className=''>

<div className='dashboard-reviews-show-list-header'>
  <div>User</div>
   <div>Reviews details</div>
   <div className='action'>Action</div>
</div>
{
  reviewsData &&
  reviewsData.map((e,i)=>(

    <div className={`${e.userType === "user" ? "user-type-bg":"" } dashboard-reviews-show-list`}>
      <div> 

        <div className='dashboard-reviews-show-user-icon'><i class="fa-solid fa-user"></i></div>
      </div>

      <div> 
        
        <div   className='dashboard-reviews-show-userName-cont'>   <div>  {e.customerName} </div>  <div> <i class="fa-solid fa-star"></i>{e.ratingNumber} </div></div> 
        <p className='dashboard-reviews-show-list-servicename' > {e.serviceDate} <span>.</span> {e.servicesName}</p> 
        <div className='dashboard-reviews-list-re-message'>  {e.ratingMessage.split(" ").slice(0, 30).join(" ")}
  {e.ratingMessage.split(" ").length > 30 ? "..." : ""}</div>

        </div>

      <div className='dashboard-reviews-show-list-action'> 
        <div className="dashboard-reviews-show-list-action-btn"
        onClick={() => handleViewClick(e._id)}
        > View</div>

        <div className="dashboard-reviews-show-list-action-btn"><i class="fa-solid fa-pen-to-square" onClick={() => handleEditClick(e)} ></i></div>

        <div className="dashboard-reviews-show-list-action-btn"><i class="fa-solid fa-trash-arrow-up" onClick={()=>DeleteRatingApi(e._id)}></i></div>
        
      </div>
    </div>
  ))
}

  {/* <div>Hellow User</div> */}


        {showPopup && (
          <ViewReviewDetails     id={selectedId} apiPath="/auth/view-ft-ratting/"
          onClose={() => setShowPopup(false)} />
        )}






{OpenEditReviews && selectedReview && (
  <UpdateReviewDetails
    review={selectedReview}
    apiUrl={apiUrl}
    onClose={() => setOpenAddReviews(false)}
    onUpdated={getReviews} // callback to refresh list
    apiRautes ="/auth/update-ft-ratting/"
    apiPostRaotes="/auth/post-ft-reviews"

    CloseForm = {setOpenEditReviews}

  />
)}
</div>


{

  ResponsePageData.totalPages> 1 ?(

  // <div> Number 2 index</div>
  
   <div style={{ marginTop: "20px" }}>
        <button onClick={prevPage} disabled={page === 1}>
          Prev
        </button>

        <span style={{ margin: "0 10px" }}>
          Page {page} of {ResponsePageData.totalPages}
        </span>

        <button onClick={nextPage}  disabled={page === ResponsePageData.totalPages}>
          Next
        </button>
      </div>
  
  ):""
}


   <div>

   </div>



      </div>

    


    
     
 
    </div>
  )
}

export default FTreviewPage;